/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Jiyeon Heo",
  title: "Hi, I'm Jiyeon",
  subTitle: emoji(
    "Software Engineer with 3 years of experience building and supporting production applications and business systems. Experienced across full-stack development, system integration, data-driven workflows, production support, and AI-powered solutions using modern web, backend, database, and cloud technologies."
  ),
  resumeLink: require("./assets/Jiyeon_Heo_Resume_v6.pdf"), // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/JIYEON-H",
  linkedin: "https://www.linkedin.com/in/jiyeon-heo/",
  gmail: "jiyeon.heo0906@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Who am I",
  subTitle: "Software engineer focused on building reliable applications and business systems that solve real-world problems.",
  skills: [
    emoji(
      "⚡ Experienced in building and supporting production applications across frontend, backend, APIs, and data layers."
    ),
    emoji("⚡ Enjoys understanding business workflows and translating requirements into practical, maintainable software solutions."),
    emoji(
      "⚡ Comfortable working across the full development lifecycle, from requirements and implementation to testing, deployment, and production support."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "C#",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "GCP",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    // Additional language experience
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "SASS",
      fontAwesomeClassname: "fab fa-sass"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Southern Alberta Institute of Technology (SAIT)",
      logo: require("./assets/images/sait.png"),
      subHeader: "Diploma in Information Technology - Software Development",
      duration: "Jan 2023 - Aug 2025",
      desc: "GPA: 3.99/4.00",
      descBullets: [
        "SAIT Student Code Club - SSC",
        "Jason Lang Scholarship — (Dec 2023)"
      ]
    },
    {
      schoolName: "EZEN IT Institute",
      logo: require("./assets/images/ezen.png"),
      subHeader: "Certificate in Java Web & App Developer",
      duration: "Jul 2021 - Dec 2021",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "POSY Inc.",
      companylogo: require("./assets/images/PosyLogo.png"),
      date: "Mar 2024 – Mar 2026",
      desc: "ERP / HCM / POS / Business Applications",
      descBullets: [
        "Designed, developed, and supported production ERP applications across inventory, purchasing, warehouse, sales, B2B ordering, and business operations",
        
        "Built full-stack features across React, TypeScript, Node.js, REST APIs, and data layers, supporting day-to-day workflows across multiple business locations",
        
        "Built data workflows supporting 6,000+ products and tens of thousands of operational records, including validation, migration, synchronization, and data consistency across business systems",
        
        "Developed event-driven backend workflows across purchasing, sales, manufacturing, and inventory auditing, with safeguards for reliable asynchronous processing and duplicate prevention",
        
        "Implemented real-time operational data updates across inventory, pricing, and shared workflows, and developed dashboards to improve visibility into day-to-day operations",
        
        "Investigated production issues across frontend, backend, APIs, and data layers, identifying root causes and implementing long-term fixes to improve system reliability",
        
        "Built an AI-powered invoice processing workflow integrating document extraction, product validation, and human review, significantly reducing manual invoice entry"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Artistry",
      companylogo: require("./assets/images/artistryLogo.png"),
      date: "Sep 2023 – Present",
      desc: "Web Platform / Content Management",
      descBullets: [
        "Developed and shipped full-stack production features using React, Next.js, TypeScript, and .NET, working across frontend interfaces and backend services",
        
        "Worked with designers and stakeholders to understand requirements and translate user needs into practical, maintainable software features",
        
        "Built administrative workflows for managing structured exhibition, media, and content data, including authentication and role-based access control",
        
        "Built and maintained CI/CD workflows with GitHub Actions and managed deployments across staging and production environments",
        
        "Developed end-to-end tests with Playwright for critical administrative workflows to improve release confidence and reduce regressions",
        
        "Contributed to the platform's AWS-to-GCP cloud migration, including application configuration, storage, deployment, and production troubleshooting"
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Some projects I have worked on",
  projects: [
    {
      projectName: "ESG Report Chat (RAG)",
      projectDesc:
        "A full-stack AI-powered Q&A application for ESG sustainability reports. Built an end-to-end RAG pipeline with PDF extraction, text chunking, OpenAI embeddings, vector similarity search, and GPT-4o to generate context-grounded answers through a Next.js frontend and Express REST API.",
      footerLink: [
        {
          name: "Visit GitHub",
          url: "https://github.com/JIYEON-H/esg-rag-chat"
        }
      ]
    },
    {
      projectName: "Relay Integration Platform",
      projectDesc:
        "A backend integration platform exploring OAuth 2.0 and third-party API architecture. Built a Google OAuth Authorization Code flow with server-side token handling, refresh token persistence, and PostgreSQL-backed integration connections using NestJS, Prisma, and Docker.",
      footerLink: [
        {
          name: "Visit GitHub",
          url: "YOUR_RELAY_GITHUB_URL"
        }
      ]
    },
    {
      projectName: "GeoAsset Connect",
      projectDesc: "A .NET-based geospatial asset management system exploring industrial asset lifecycle workflows and field-driven data modeling. Built with C#, EF Core, SQL Server, and Docker to support structured operational processes, relational data integrity, and scalable backend architecture.",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/JIYEON-H/Calgary-GeoAsset-Project"
        }
      ]
    },
    {
      projectName: "Proxy Voting Dashboard",
      projectDesc:
        "An interactive voting analytics dashboard built with React, TypeScript, and Recharts to visualize how institutional investors voted across shareholder resolutions. Features responsive data visualization, grouped bar charts, dual-perspective analysis, interactive filtering, and reusable UI architecture focused on clarity and usability.",
      footerLink: [
        {
          name: "Live Demo",
          url: "https://proxy-voting-dashboard.vercel.app"
        },
        {
          name: "Visit GitHub",
          url: "https://github.com/JIYEON-H/proxy-voting-dashboard"
        }
      ]
    },
    {
      projectName: "AI Invoice Parser (Smart Invoice Extractor)",
      projectDesc: "Built an AI-assisted invoice extraction workflow to reduce manual data entry. Extracts key fields from invoice images/PDFs and maps them into structured records for ERP purchasing and inventory workflows.",
      footerLink: [
        {
          name: "Demo Video",
          url: "https://www.youtube.com/watch?v=8_m3g9tY9uM" // 또는 Vimeo 링크
        }
      ]
    },
    {
      projectName: "Care INC Audiology project",
      projectDesc: "An intuitive Inventory Management System designed to replace manual tracking with automation. It simplifies stock management, package assignments, and ordering processes, ensuring efficiency and accuracy for audiologists.",
      footerLink: [
        {
          name: "Visit Github (Frontend)",
          url: "https://github.com/Reann-Shepard/care-inc-IMS-frontend"
        },
        {
          name: "Visit Github (Backend)",
          url: "https://github.com/Reann-Shepard/care-inc-IMS-backend"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Itinerary App",
      projectDesc: "Plan your journey. Our itinerary App is designed to optimize your travel experience. This app helps users easily plan and manage their travel itineraries. Travelers can create itineraries including destinations, itineraries, activities, etc., and view the locations of their travel destinations.",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/Laurenchansj/WebDancers"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // image: require("./assets/images/nextuLogo.webp"),
      projectName: "Expense Tracker",
      projectDesc: "Set budgets and track your spending. Our Expense Tracker App is designed to help you manage your finances. This app helps users easily track their expenses and manage their budgets. Users can create budgets, track expenses, and view their spending habits.",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/HarryLee87/MoneyDancers"
        }
      ]
    },
    {
      // image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Word Tracker",
      projectDesc: "This word tracking program utilizes a binary search tree data structure to store all the words from text files along with their file names, line numbers, and frequency. It organizes and displays the words in alphabetical order.",
      footerLink: [
        {
          name: "Visit GitHub",
          url: "https://github.com/JIYEON-H/WordTracker"
        }
      ]
    },
    {
      // image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Library Management",
      projectDesc: "Manage your library. Our Library Management App is designed to help you manage your library. This app helps users easily manage their library. Users can add books, manage book loans, and view their library inventory.",
      footerLink: [
        {
          name: "Visit GitHub",
          url: "https://github.com/SarahNT1/Library_Management"
        }
        //  you can add extra buttons here.
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: ""
        },
        {
          name: "Award Letter",
          url: ""
        },
        {
          name: "Google Code-in Blog",
          url: ""
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: ""
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: ""
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Coming soon...",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "",
      title: "Coming Soon",
      description:
        "Coming soon..."
    },
    {
      url: "",
      title: "Coming Soon",
      description:
        "Coming Soon"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "",
  email_address: "jiyeon.heo0906@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
